import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./input.css";
import { firebase } from "./firebase";
import VueClipboard from "vue3-clipboard";
import { getAnalytics } from "firebase/analytics";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebase";

const analytics = getAnalytics();

import { OhVueIcon, addIcons } from "oh-vue-icons";
import {
  CoGmail,
  BiFacebook,
  BiTwitter,
  BiReddit,
  BiLinkedin,
  BiWhatsapp,
  BiMessenger,
  BiTrophy,
  FaSms,
  SiGooglechrome,
  FaBrain,
  HiDocumentAdd,
  HiDocumentText,
  BiCardText,
  BiCalendarDate,
  BiCardChecklist,
  BiQuestionCircle,
  FaUserCircle,
  HiCollection,
  CoChartLine,
  CoLibraryAdd,
  HiLogout,
  HiMenu,
  IoClose,
  BiYoutube,
  CoApplePodcasts,
  CoGooglePodcasts,
  BiFileEarmarkPdf,
  BiFileEarmarkWord,
  BiNewspaper,
  CoWikipedia,
  BiMedium,
  MdChromereadermodeOutlined,
  MdMorehorizSharp,
  SiSubstack,
} from "oh-vue-icons/icons";
addIcons(
  CoGmail,
  BiFacebook,
  BiTwitter,
  BiReddit,
  BiLinkedin,
  BiWhatsapp,
  BiMessenger,
  BiTrophy,
  FaSms,
  SiGooglechrome,
  FaBrain,
  HiDocumentAdd,
  HiDocumentText,
  BiCardText,
  BiCalendarDate,
  BiCardChecklist,
  BiQuestionCircle,
  FaUserCircle,
  HiCollection,
  CoChartLine,
  CoLibraryAdd,
  HiLogout,
  HiMenu,
  IoClose,
  BiYoutube,
  CoApplePodcasts,
  CoGooglePodcasts,
  BiFileEarmarkPdf,
  BiFileEarmarkWord,
  BiNewspaper,
  CoWikipedia,
  BiMedium,
  MdChromereadermodeOutlined,
  MdMorehorizSharp,
  SiSubstack,
);

const app = createApp(App).use(router);
app.component("v-icon", OhVueIcon);
app.config.devtools = true;
app.config.globalProperties.global;
app.config.errorHandler = async (err, vm, info) => {
  try {
    await addDoc(collection(db, "debugging"), {
      createdAt: Timestamp.fromDate(new Date()),
      error: JSON.stringify(err),
      vm: JSON.stringify(vm),
      info: JSON.stringify(info),
      type: "frontend",
    });
  } catch (error) {
    console.log(error);
  }
};
app.use(firebase);
app.use(analytics);
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
});

app.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
  timeout: 2000,
});

app.mount("#app");
